<div class="breeding-list">
    <div class="breeding-list-popup">
        <div class="breeding-list__container">
            <div class="breeding-list__body">
                <button class="breeding-list__close" (click)="closePopup()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.192 4.34399L9.94897 8.58599L5.70697 4.34399L4.29297 5.75799L8.53497 9.99999L4.29297 14.242L5.70697 15.656L9.94897 11.414L14.192 15.656L15.606 14.242L11.364 9.99999L15.606 5.75799L14.192 4.34399Z"
                            fill="white" />
                    </svg>
                </button>
                <h2 class="breeding-list__title">Choose a creature</h2>
                <div class="breeding-list__inner">
                    <div class="list marketplace">
                        <div class="container">
                            <div class="list__header">
                                <button class="list__header-filter">
                                    <span>
                                        <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1ZM2 6C2 5.44772 2.44772 5 3 5H13C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7H3C2.44772 7 2 6.55228 2 6ZM5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H5Z"
                                                fill="white" />
                                        </svg>
                                    </span>Filters<span class="num">{{countOfFilterChanged}}</span></button>
                            </div>
                            <div class="marketplace__inner">
                                <filter-creature-component [(filter)]="filter" (filterChange)="onFilterChange()"></filter-creature-component>
                                <div class="list__inner" (scroll)="onScroll($event)" style="overflow-y: auto; max-height: 70vh;">
                                    @for (creature of creatures; track creature) {
                                    <div class="list__item" (click)="onSelectCreature(creature)">
                                        <div class="list__card">
                                            <item-creature-component [creature]="creature"></item-creature-component>
                                        </div>
                                    </div>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section *ngIf="showLoading" class="loader-box">
        <span class="loader"></span>
    </section>
</div>